export const locale = {
  lang:'zh1',
  data: {
    'RESULTADOS': {
      'TITULO':	'報告',
      'DESCRIP':	'選擇一個選項',
      'CARGANDO':'加載公司調查結果',
      'COMINGSOON': 'COVID調查結果即將發布...',
      'VALIDANDO': {
        'BOTON': '在驗證過程中',
        'MENSAJE': '該產品的結果正在驗證過程中，很快就會為您提供',
      },

      'TABLAPRODUCTOS':{
        'COL1':'年',
        'COL2':'訪問',
        'BOT':'訪問',
      },

      'SECCIONES': {
        'TITULO_VER':'版 ',
        'NOSECCIONES':	'沒有可用部分',

        'CERTIFICAR': {
          'TITULO':'證書',
          'INFO':'選擇您要諮詢的年份',
          'BOTON':'輸入'
        },
        'MEDIR': {
          'TITULO':'措施',
          'INFO':'選擇您要諮詢的年份',
          'BOTON':'輸入'
        },
        'PULSE': {
          'TITULO':'新聞檢查',
          'INFO':'選擇您要諮詢的年份',
          'BOTON':'輸入'
        },
        'MEDIR_AMCO': {
          'TITULO': 'ICI',
          'INFO':'選擇您要諮詢的年份',
          'BOTON':'輸入'
        },
        'MEDIR_INNO': {
          'TITULO': 'Innmotion survey',
          'INFO':'選擇您要諮詢的年份',
          'BOTON':'輸入'
        },
        'CertiAdicio': {
          'TITULO': '其他認證',
          'INFO':'選擇您要諮詢的年份',
          'BOTON':'輸入'
        },
        'Amco': {
          'TITULO': '安科',
          'INFO': '選擇您要諮詢的年份',
          'BOTON': '輸入'
        },
        'TrabDign': {
          'TITULO': '體面的工作',
          'INFO': '選擇您要諮詢的年份',
          'BOTON': '輸入'
        },
        'PrimEmp': {
          'TITULO': '第一份工作',
          'INFO': '選擇您要諮詢的年份',
          'BOTON': '輸入'
        },
        'GOFLOW': {
          'TITULO': '結果 GoFlow',
          'INFO': '選擇您要諮詢的年份',
          'BOTON': '輸入'
        },
      },
      'TABPRIN':{
        'TABPRO':'認證過程',
        'TAB4ALL':'全部結果',
        'TAB4ALL2':'處理結果',
         'TITURES':'全部結果',
        'TABCER':'測量過程',
        'TABPULSE':'脈衝檢查程序',
        'TABICI': 'ICI結果',
        'TABINNO': 'Innmotion survey結果',
        'TABAMCO': 'AMCO 流程',
        'TABTRABDIG':'體面的工作流程',
        'TABPRIEMP':'首次就業流程',
        },

        '4ALLVIEJAS':{
         'TITULO': '永遠繼承的結果',
         'BOTON': 'Start',
         'SIN_4ALL_HEREDADAS':"您不指望繼承的Forall結果",
         'TITULOCERTIFICAR':'證明',
         'APLICACIONANIO':'申請年份：2019',
        },


      '4ALL':{
        'TITULO4ALL':  '實踐結果',
        'TABPRACTICAS':   {
          'TITULOTAB':  '4全部實踐',
          'TITULOPRACGLOBAL':   {
            'SUBTITULOPRAC':  'FORALL做法的全球結果',
            'TEXTO1':  '百分比',
            'TEXTO2':  '了解FORALL慣例',
            'TEXTO3':  '在您的組織中',
            'TEXTO4':  'Level of',
            'TEXTO5':  '他們認識的合作者的滿意度',
            'TEXTO6':  'FORALL慣例',
          },
          'TITULOPRAC4All':   {
            'TITULOTAB':  '受眾特徵',
            'SUBTITULO4ALL':  'FORALL做法的結果',
            'TITULOCONO':  '知識',
            'TEXTO1':  '您組織中FORALL實踐的知識百分比',
            'TITULOSATIS':  '滿足',
            'TEXTO2':  '了解FORALL慣例的員工的滿意度',
          }
        },

        'DEMOGRAFICOS':{
          'Cargo homologado ':'批准的貨物',
          'Años de Trabajo':'古董',
        'Condición de trabajo':'工作條件',
      'Tipo de trabajo': '補償方案',
        'Género':'性別',
          'Educación':'學術學位',
          'PORCONOTXT1':'百分比',
          'PORCONOTXT2':'了解FORALL做法',
          'PORCONOTXT3':'按受眾特徵劃分',
          'PORSATITXT1':'級別',
          'PORSATITXT2':'了解FORALL慣例的合作者的滿意度',
          'PORSATITXT3':'按受眾特徵劃分',
        },
        'MODL_N_RESU':'目前沒有結果',
        'MODL_N_RESU_4ALL':'無法顯示請求的結果',
      },
      "ETIQ_MODAL_RESULT":{
        "TITLE_MODA":'沒有找到結果平台鍵',
         "ETQ_PROD": "產品：",
         "ETQ_BROK": "經紀人：",
         "ETQ_COUN": "國家：",
         "ETQ_LANG": "語言：",
         "ETQ_CERTY": "證書：",
         "true":"啟用",
         "false": "已禁用",
         "COUNTR_NO_SELEC":"*未選中的*",
      }
    },
    'CONFING_RESUL':{
    'TITULO_MODAL':'BenchMarks 結果配置',
    'TAB_DEMO_EXCEL':'Excel人口統計',
    'SUB_TIT_TAB_DEMO_EXCEL':'選擇受眾特徵：',
    'TAB_DEMO_ENCU':'人口統計調查',
    'SUB_TIT_TAB_DEMO_ENCU':'選擇受眾特徵：',
    'TAB_BENCHMA':'基準',
    'SUB_TIT_TAB_BENCHMA':'',
    'TITULO_MAT_EXPAN_TAMANO':'最佳',
    'TITULO_MAT_EXPAN_SECTOR':'部門性的',
    'TITULO_MAT_EXPAN_REGIONAL':'範圍',
    'OKSELECT':'選中',
    'NOTSELECT':'未選中',
    'TAB_NIV_GEOG':'地理等級',
    'SUB_TIT_TAB_NIV_GEOG':'選擇地理級別：',
    'TAB_NIV_ESTRUC':'結構層次',
    'SUB_TIT_TAB_NIV_ESTRUC':'選擇結構級別：',
    'BTN_ACEPTAR':'接受',
    'MODAL_CARGA_DEMO_EXC':'載入人口統計資料',
    'MODAL_CARGA_DEMO_ENC':'正在加載調查受眾特徵',
    'MODAL_CARGA_BENCH':'載入基準',
    'MODAL_CARGA_NIV_GEO':'加載地理級別',
    'MODAL_CARGA_NIV_ESTR':'加載結構層',
    'TAB_BENCH_MARK':'基準',
    'MODAL_CARGA_BENCH_MARK':'加載基準',
    'SUB_TIT_TAB_BENCH_MARK':'選擇基準',
    'SUCCES_GUAR_SELEC':'修改已正確保存',
    'CONFI_GUAR_SELE':'¿確定要保存所做的更改嗎？',
    'RES_SI':'是',
    'RES_NO':'否',
    'MAT_TOOL_BTN_CONFI_RESULT':'結果配置',
    'MODAL_GUA_INFOR':'保存信息',
    'SUB_TIT_TAB_HIERARCHI':'層次路徑選擇：',
    'MODAL_CARGA_HIERARCHI':'加載層次路徑',
    'SIN__HIERARCHI_MOSTRAR':'hierarchyPaths 中目前沒有結果',
    'EXTERNAL_PORTAL':'複製外部4all的url',
    'INTRU_TEX_BENCHMARK':'*移動基準',
       'BENCHMARCK_SELEC':'按呈現順序選擇的BenchMark：',
       'BTN_SAV_BENCH':'保存基準',
       'TEX_SEARC_BENCH_TOP':'輸入頂級基准進行搜索',
       'TEX_SEARC_BENCH_SECT':'輸入扇區基准進行搜索',
       'TEX_SEARC_BENCH_RANG':'輸入要搜索的基準範圍',
       'INFO_MAS_BENCH_ESPA':'組基準',
       'BTN_ADD_BENCH_SUGE':'添加建議',
       'MOD_WARN_MAX_PERMIT':'無法添加，因為超過了允許的空格數',
       'MOD_WARN_UN_CATE':'當前已存在所選類別的基準',
       'MOD_WARN_NO_APLIC':'無法添加它，因為不選擇基準的選項已啟用。',
       'INSTRU_DRAP&DROP_1':'將 BenchMark 拖放到此處',
       'LABE_CIRC_PROGRE':'基準',
       'LABE_INSTRU_SELECT_BENCH':'¿您想選擇 BenchMark 嗎？',
  },
  'CONFING_RESUL_GOFLOW':{
  'TITULO_MODAL':'GoFlow 結果信息',
    },
  'CONFING_RESUL_EMP':{
    'TITULO_MODAL':'原始數據啟發',
         'INT_TEX':'說明：請上傳要導入的原始數據文件',
         'TOOLT_CHA_INF':'我選擇了文件',
         'UPLO_INF':'導入行數據',
         'SUCC_UPLO_INF':'導入成功',
  }
  }
};
